/**
 * @file Modal
 */
'use strict'

/**
 * @classname Languages
 * @classdesc Languages
 */
export default class Languages {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Languages.constructor')
		this._$e = $e
		this._$selectLanguage = $('#select-language')
		this._$languages = $e.find('li')
		this._$languages.each((index, e) => {
			if ($(e).hasClass('selected')) {
			  this._$selectLanguage.text($(e).html());
			}
		});
		this._$languages.on('click', e => this.onClick(e));
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof Languages
	 * @return {undefined}
	 */
	 onClick(e) {
		console.log('Languages.onClick')
		this._$selectLanguage.text($(e.target).html());
		this._$languages.removeClass('selected');
		$(e.target).addClass('selected');
	}
}
